import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=3a28c5f0&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./dash.js?vue&type=script&lang=js&"
export * from "./dash.js?vue&type=script&lang=js&"
import style0 from "./Dash.vue?vue&type=style&index=0&id=3a28c5f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports